import React from 'react';
import { captureException } from '../analytics/analytics';

export function isChunkLoadError(error) {
  return /ChunkLoadError|Loading (?:CSS )?chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(`${error?.name} ${error?.message}`);
}

export function RecoveryScreen({ error, onRetry }) {
  const chunk = isChunkLoadError(error);
  return <main role="alert" className="min-h-screen bg-[#101010] px-5 py-20 text-white">
    <div className="mx-auto max-w-lg rounded-2xl border border-white/15 p-6">
      <h1 className="text-2xl font-semibold">{chunk ? 'This part of the app couldn’t load' : 'Let’s get you back to your song'}</h1>
      <p className="mt-4 leading-relaxed text-white/75">{chunk ? 'Check your connection, then reload to get the latest app.' : 'The app ran into a problem. You can reopen it below.'}</p>
      <p className="mt-3 leading-relaxed text-white/75">Songs already started keep processing in your account. Reopening the app does not use more credits. Your saved drafts will be restored.</p>
      <button type="button" className="mt-6 min-h-[48px] w-full rounded-xl bg-[#7357ff] px-5 py-3 font-semibold" onClick={chunk ? () => window.location.reload() : onRetry}>{chunk ? 'Reload app' : 'Reopen app'}</button>
      {!chunk && <button type="button" className="mt-3 min-h-[44px] w-full rounded-xl border border-white/25 px-5 py-3" onClick={() => window.location.reload()}>Reload page</button>}
    </div>
  </main>;
}

export default class AppRecoveryBoundary extends React.Component {
  state = { error: null, attempt: 0 };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    captureException(error, { area: 'app_render', component_stack: info.componentStack, chunk_load: isChunkLoadError(error) });
  }
  render() {
    if (this.state.error) return <RecoveryScreen error={this.state.error} onRetry={() => this.setState(({ attempt }) => ({ error: null, attempt: attempt + 1 }))} />;
    return <React.Fragment key={this.state.attempt}>{this.props.children}</React.Fragment>;
  }
}
